<template>
    <div class="table-box">
        <Table :columns="columns" :data="list">
            <!-- 合同编号 -->
            <template slot-scope="{ row, index }" slot="sn">
                <Tooltip content="业务员已线上签署合同，不支持变更" v-if="row.type == 1" style="width: 100%">
                    <Input
                        v-model="list[index].sn"
                        placeholder="请输入"
                        :class="{ error: row.snError }"
                        @on-click="row.snError = false"
                        :disabled="row.type == 1"
                    />
                </Tooltip>
                <Input
                    v-else
                    v-model="list[index].sn"
                    placeholder="请输入"
                    :class="{ error: row.snError }"
                    @on-click="row.snError = false"
                />
            </template>
            <!-- 合同名字 -->
            <template slot-scope="{ row, index }" slot="subject">
                <Input
                    v-model="list[index].subject"
                    placeholder="请输入"
                    :class="{ error: row.subjectError }"
                    @on-click="row.subjectError = false"
                    :disabled="row.type == 1"
                />
            </template>
            <!-- 合同文件 -->
            <template slot-scope="{ row, index }" slot="upload">
                <Upload :show-upload-list="false" :multiple="false" action="/" :before-upload="file => handleUpload(file, index)">
                    <span v-if="row.uploading">{{ row.uploadPercent || 0 }}%</span>
                    <span class="table-btn org" v-else-if="row.documentUrls">重新上传</span>
                    <span class="table-btn" v-else :class="{ red: row.fileError }">上传文件</span>
                </Upload>
            </template>
            <!-- 合同名字 -->
            <template slot-scope="{ row, index }" slot="action">
                <span class="table-btn" @click="openFile(row)" :class="{ disabled: !row.documentUrls }">预览</span>
                <span class="table-btn" @click="del(index)" v-if="row.type == 2 || !row.type">删除</span>
            </template>
        </Table>
    </div>
</template>

<script>
import { uploadFile } from '@/api/httpList';
export default {
    data() {
        return {
            visible: false,
            loading: false,
            params: {},
            list: [],
            columns: [
                {
                    title: '序号',
                    align: 'center',
                    width: 80,
                    type: 'index'
                },
                {
                    title: '合同编号',
                    slot: 'sn',
                    align: 'center'
                },
                {
                    title: '合同名称',
                    slot: 'subject',
                    align: 'center'
                },
                {
                    title: '合同文件',
                    slot: 'upload',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 120,
                    align: 'center'
                }
            ]
        };
    },

    methods: {
        add() {
            this.list.push({});
        },
        del(i) {
            this.list.splice(i, 1);
        },
        openFile(item) {
            var url = item.documentUrls[0].path;
            window.open(url);
        },
        handleUpload(file, index) {
            console.log('handleUpload', file, index);
            if (!file) {
                return;
            }
            //  上传文件只能是 PDF 格式!
            const reg = /\.(pdf)$/;
            const txt = 'PDF';
            if (!reg.test(file.name.toLowerCase())) {
                this.$notice.error(`上传格式不正确，请上传${txt}格式文件`);
                return false;
            }
            let formData = new FormData();
            formData.append('file', file);
            this.$set(this.list[index], 'uploading', true);
            uploadFile(formData, e => {
                const progress = +((e.loaded / e.total) * 100).toFixed(2);
                this.$set(this.list[index], 'uploadPercent', progress);
            }).then(res => {
                // res.data 是数组
                this.$set(this.list[index], 'documentUrls', res.data);
                this.$set(this.list[index], 'uploading', false);
                this.$set(this.list[index], 'fileError', false);
            });
            return false;
        },
        check() {
            let isok = true;
            if (this.list.length) {
                this.list.forEach(item => {
                    this.$set(item, 'fileError', !item.documentUrls);
                    this.$set(item, 'subjectError', !item.subject);
                    this.$set(item, 'snError', !item.sn);
                    if (item.fileError || item.subjectError || item.snError) {
                        isok = false;
                    }
                });
            } else {
                isok = false;
            }
            if (!isok) {
                this.$notice.error('请完善合同信息');
            }
            return isok;
        },
        getData() {
            return this.list.map(item => {
                return {
                    sn: item.sn,
                    subject: item.subject,
                    documentUrls: item.documentUrls
                };
            });
        },
        setData(list) {
            let preview = false;
            list.forEach(item => {
                if (item.type == 1) {
                    preview = true;
                }
            });
            if (preview) {
                this.columns.splice(3, 1);
            }
            this.list = list;
        }
    }
};
</script>
<style lang="scss" scoped>
.table-box {
    margin-top: -10px;
    margin-bottom: 20px;
    .error /deep/ input {
        border-color: #ed4014;
        &::placeholder {
            color: #ed4014;
        }
    }
}
</style>
